import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { reverse } from 'named-urls';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommonTable from '../../common/components/CommonTable';
import VehiclesTableRow from './VehiclesTableRow';
import CommonLoader from '../../common/components/CommonLoader';
import RouterPaths from '../../constants/RouterPaths';
import { SET_SELECTED_VEHICLE, SET_VEHICLES_SEARCH_PARAMS } from '../VehicleReducer';

const headers = [
  {
    label: 'VRM',
  },
  {
    label: 'Title',
  },
  {
    label: 'Registration date',
  },
  {
    label: 'Cap clean',
  },
  {
    label: 'Launch date',
  },
  {
    label: 'End date',
  },
  {
    label: 'Offer type',
  },
  {
    label: 'Buyer',
  },
  {
    label: 'Buyer Location',
  },
  {
    label: 'Seller',
  },
  {
    label: 'Seller Location',
  },
  {
    label: 'User',
  },
  {
    label: 'Status',
  },
  {
    label: 'Offer ID',
  },
  {
    label: 'Actions',
    className: 'text-right',
  },
];

function VehiclesTable({ data, offset, setOffset, searchParams }) {
  const loaderStatus = useSelector((state) => state.vehicles.get('loaderStatus'));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRowClick = (item) => {
    dispatch({ type: SET_SELECTED_VEHICLE, payload: item.id });
    dispatch({ type: SET_VEHICLES_SEARCH_PARAMS, payload: searchParams });
    navigate(reverse(RouterPaths.EDIT_VEHICLE, { id: item.id }));
  };

  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            rowIdPrefix="vehicle-row"
            rowComponent={VehiclesTableRow}
            data={data}
            offset={offset}
            onOffsetChange={setOffset}
            headers={headers}
            title="Vehicles"
            onRowClick={handleRowClick}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

VehiclesTable.propTypes = {
  searchParams: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  setOffset: PropTypes.func.isRequired,
};

export default VehiclesTable;
